import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
//import rootSaga from '../state/sagas/rootSaga';
import rootSaga from '../app/rootSaga';
import rootReducer from '../app/rootReducer';

// Khởi tạo middleware saga
const sagaMiddleware = createSagaMiddleware();

// Cấu hình store với configureStore của Redux Toolkit
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware): any =>
        getDefaultMiddleware({
            thunk: false
        }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production' // Bật redux-devtools trong môi trường phát triển
});

// Khởi chạy saga
sagaMiddleware.run(rootSaga);

// Định nghĩa AppDispatch type để sử dụng trong dự án
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
